import classnames from "classnames";
import React, { ReactNode } from "react";
import { findDataAttrProps } from "../../../utils/props";
import styles from "./Row.module.scss";

type Props = {
  align?: "center" | "left" | "right";
  children: ReactNode;
  className?: string;
  justify?: "around" | "between" | "baseline" | "center";
  style?: React.CSSProperties;
  valign?: "bottom" | "middle" | "top";
  dir?: "ltr" | "rtl";
};

const Row = (props: Props) => {
  const { align, children, className, justify, style, valign, ...rest } = props;
  const cssStyles = classnames(
    "row",
    className,
    align === "left" && styles.textLeft,
    align === "center" && styles.textCenter,
    align === "right" && styles.textRight,
    justify === "around" && styles.around,
    justify === "between" && styles.between,
    justify === "baseline" && styles.baseline,
    justify === "center" && styles.center,
    valign === "top" && styles.top,
    valign === "middle" && styles.middle,
    valign === "bottom" && styles.bottom
  );

  return (
    <div
      {...findDataAttrProps(props)}
      className={cssStyles}
      style={style}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Row;
